import React, {useEffect, useState} from 'react';
import {
  Chip,
  Autocomplete,
  TextField,
  Typography,
  Button
} from '@mui/material';
import Box from '@mui/material/Box';
import ColorizeIcon from '@mui/icons-material/Colorize';
import api from '../../../services/api';
import CircularProgress from '@mui/material/CircularProgress';
import LargePopper from '../assets/LargePopper';
import {SlidingPaneAddNew} from "../../Page/SlidingPaneAddNew";
import AddIcon from "@mui/icons-material/Add";

export default function SingleSelectMUI({
  params,
  column,
}: {
  params: any;
  column: any;
}) {
  const [selectOptions, setSelectOptions] = useState<[]>([]);
  const [addingEntity, setAddingEntity] = useState(false);
  const [loading, setLoading] = useState(false);
  const transformedValue = params.value;

  const [openedSlidingPaneAddNew, setOpenedSlidingPaneAddNew] = useState<any>({
    schema: column?.tempSchema,
    row: {},
  });

  const fetchSelectOptions = async (searchText: string) => {
    setLoading(true);

    let string: any = {
      searchValue: searchText,
    };

    let accordingToSendData: any = undefined;

    if (column?.accordingTo){

      const key = column?.accordingTo;

      if (
        params?.row[key] !== undefined &&
        params?.row[key] !== null &&
        params?.row[key] !== ''
      ) {
        const accordingToData: any = params?.row[key];
        accordingToSendData = {
          name: key,
          id: accordingToData?.id,
          value: params?.row[key],
        };
      }
    }

    if (accordingToSendData) {
      string.accordingToLabel = accordingToSendData?.name;
      string.accordingToId = accordingToSendData?.id;
      string.accordingToValue = accordingToSendData?.value;
      string.withName = true;
    }
    const searchParams = new URLSearchParams(string);

    if (column?.fieldType === 'address'){
      searchParams.set('group_id', params?.row?.group_id);
    }

    if (
      column?.fieldType === 'custom_field_for_service_reservation_staff'
      ||
      column?.fieldType === 'custom_field_for_service_reservation_driver'
      ||
      column?.fieldType === 'custom_field_for_service_reservation_vehicle'
    ){
      searchParams.set('service_provider_id', params?.row?.service_provider?.id);
      searchParams.set('service_id', params?.row?.service?.id);
    }

    if (column?.url) {

      let url = `/${column?.url}/names`;
      if (column?.fieldType == 'custom_field_for_service_reservation_staff'){
        url = `/admin/get-staff-by-service`;
      }
      if (column?.fieldType == 'custom_field_for_service_reservation_driver'){
        url = `/admin/get-driver-by-service`;
      }
      if (column?.fieldType == 'custom_field_for_service_reservation_vehicle'){
        url = `/admin/get-vehicle-by-service`;
      }

      api.get(url, searchParams).then((result: any) => {
        if (result?.data) {
          result.data.unshift({ id: 0, name: '', isButton: true });
          setSelectOptions(result.data);
        } else {
          result.unshift({ id: 0, name: '', isButton: true });
          setSelectOptions(result);
        }

        setLoading(false);
      });
    }
  };

  const onChange = (event: any, value: any) => {
    if (value?.isButton) {
      setOpenedSlidingPaneAddNew({...openedSlidingPaneAddNew, row: params?.row});
    } else {
      params.api.setEditCellValue({
        id: params.id,
        field: params.field,
        value: value,
      });
    }
  };

  const [searchText, setSearchText] = useState('');
  const [filteredOptions, setFilteredOptions] = useState([]);

  useEffect(() => {

    if (searchText === '') {
      setFilteredOptions(selectOptions); // Ha nincs keresés, minden opció látható
    } else {
      setFilteredOptions(
        selectOptions.filter((option: any) => {
          const nameMatches = option?.name
            ? option.name.toLowerCase().includes(searchText.toLowerCase())
            : false;
          return nameMatches;
        })
      );
    }
  }, [searchText, selectOptions]);

  return (
    <>
      <Autocomplete
        sx={{
          '& .MuiOutlinedInput-root': {
            padding: '0',
            paddingRight: '15px !important',
          },
          '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '& .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
            paddingTop: '0px',
            paddingBottom: '0px',
          },
          '& .MuiOutlinedInput-root .MuiAutocomplete-endAdornment': {
            right: '0px',
          },
        }}
        componentsProps={{
          clearIndicator: {
            sx: {
              display: 'none',
            },
          },
        }}
        PopperComponent={LargePopper}
        onOpen={() => fetchSelectOptions('')}
        fullWidth={true}
        size="small"
        loading={loading}
        options={filteredOptions}
        renderOption={(props: any, option: any) => {
          return (
            <Box
              component="li"
              sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
              {...props}
            >
              {option?.isButton && (
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  size={'small'}
                  fullWidth
                >
                  Add new
                </Button>
              )}
              {option?.color && typeof option?.color === 'string' ? (
                <Chip
                  style={{
                    background: `#${option?.color}`,
                    color: '#fff',
                  }}
                  icon={
                    <ColorizeIcon color={'disabled'} sx={{ color: 'white' }} />
                  }
                  label={`#${option.name}`}
                />
              ) : (
                <Typography
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                  }}
                >
                  {option.name ? (
                    <>
                      <Typography>{option?.name} </Typography>
                      {option?.sub_title && (
                        <Typography color={'#666'}>
                          {' '}
                          ({option?.sub_title})
                        </Typography>
                      )}
                    </>
                  ) : (
                    <>
                      <Typography>{option?.sub_title}</Typography>
                    </>
                  )}
                </Typography>
              )}
            </Box>
          );
        }}
        getOptionLabel={(option) => {
          if (option?.name) {
            return option.name;
          }

          if (
            option?.zip_code ||
            option?.city ||
            option?.address_line1 ||
            option?.address_line2
          ) {
            return `${option?.zip_code} ${option?.city} ${option?.address_line1} ${option?.address_line2}`;
          }

          return option.name;
        }}
        getOptionKey={(option) => option?.id}
        isOptionEqualToValue={(option, value) => {
          return option.id === value.id;
        }} // Use the new prop name and type
        value={transformedValue?.disabled ? null : transformedValue}
        onChange={(event, newValue) => {
          onChange(event, newValue);
        }}
        onInputChange={(event, newInputValue, reason) => {
          if (reason === 'input') {
            setSearchText(newInputValue);
          }
        }}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              /*label="Type here..."*/
              size="small"
              InputLabelProps={{
                style: {
                  fontSize: 13,
                  paddingTop: 2,
                },
              }}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {loading ? (
                      <CircularProgress
                        color="inherit"
                        size={20}
                        className={
                          'absolute right-[9px] text-[#b7b7b7] top-[1px]'
                        }
                      />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          );
        }}
        disabled={transformedValue?.disabled}
      />


      {openedSlidingPaneAddNew?.row?.id && (
        <>
          <SlidingPaneAddNew
            schema={openedSlidingPaneAddNew?.schema}
            id={
              openedSlidingPaneAddNew?.hasOwnPane
                ? undefined
                : openedSlidingPaneAddNew?.row?.id
            }
            onSubmit={() => {
              setOpenedSlidingPaneAddNew({
                schema: column?.tempSchema,
                row: {},
              });
            }}
            propertiesFromTable={
              openedSlidingPaneAddNew?.row ? openedSlidingPaneAddNew?.row : {}
            }
            onClose={(value) => {
              setOpenedSlidingPaneAddNew({
                schema: column?.tempSchema,
                row: {},
              });
            }}
          />
        </>
      )}
      {/*{addingEntity && (
        <EntityDialog
          schema={column?.tempSchema}
          //row={params}
          onClose={() => {
            return setAddingEntity(false);
          }}
          isOpen={addingEntity}
          onSubmit={(value) => {

          }}
        />
      )}*/}
    </>
  );
}
